import { DHcovers } from "./DHcovers";
import { RiskDetails_DH } from "./RiskDetails_DH";
import { ClaimsHistory_DH } from "./ClaimsHistory_DH";
import { BeneficiaryDetails_DH } from "./BeneficiaryDetails_DH";
import { GenderMaster, CityMaster, ProfessionMdl, RelationMdl, BankMaster } from "./BindMdl";
import { NationalityMasterList } from "./NationalityMasterList";

export class mdlProposalSaveReq {
    public RegNo: number;
    public ProposalNo: number;
    public IsEditProposal: boolean;
    public Insured_IDNo: string;
    public Insured_Name: string;
    public Insured_DOB: Date | string;
    public Insured_DOB_Hijri: string;
    public Insuerd_Age_AsOnDate: number;
    public Insured_Gender: number;
    public Insured_Nationality: number;
    public Insured_Nationality_ArDesc: string;
    public Insured_Nationality_EnDesc: string;
    public Insured_MobileNo: string;
    public Insured_TelephoneNo: string;
    public Insured_EmailId: string;
    public Insured_Profession: number;
    public BankCode: number;
    public Insured_BuildingNo: number;
    public Insured_Street: string;
    public Insured_District: string;
    public Insured_City: number;
    public Insured_City_ArDesc: string;
    public Insured_City_EnDesc: string;
    public Insured_PostalCode: number;
    public Insured_AdditionalCode: number;
    public Insured_UnitNo: number;

    public IsCityExists: boolean;
    public IsStreetExists: boolean;
    public IsDistrictExists: boolean;
    public IsPostalCodeExists: boolean;
    public IsAdditionalCodeExists: boolean;
    public IsUnitNoExists: boolean;
    public IsBuildingNoExists: boolean;

    public Insured_Region: string;
    public PolicyFromDate: Date | string;
    public PolicyToDate: Date | string;
    public IsClaimsHistory: boolean;
    public TaxRegNo: string;
    public UprVatAmount: number;
    public UserId: number;
    public LangFlag: string;
    public IBANNo: string;
    public IBAN1: string;
    public IBAN2: string;
    public IBAN3: string;
    public IBAN4: string;
    public IBAN5: string;
    public IBAN6: string;
    public Bankname: string;
    public SelectedCovers: Array<DHcovers> = new Array<DHcovers>();
    public RiskDetails: Array<RiskDetails_DH> = new Array<RiskDetails_DH>();
    public ClaimsHistory: Array<ClaimsHistory_DH> = new Array<ClaimsHistory_DH>();
    public BeneficiaryDetails: Array<BeneficiaryDetails_DH> = new Array<BeneficiaryDetails_DH>();
    public GenderList: Array<GenderMaster> = new Array<GenderMaster>();
    public CityMasterList: Array<CityMaster> = new Array<CityMaster>();
    public profList: Array<ProfessionMdl> = new Array<ProfessionMdl>();
    public relationList: Array<RelationMdl> = new Array<RelationMdl>();
    public NationalityMasterList: Array<NationalityMasterList> = new Array<NationalityMasterList>();
    public bankList: Array<BankMaster>=new Array<BankMaster>();
    public StatusCode: string;
    public StatusDesc: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlProposalSaveReq.ts